/* AZFindings product page scripts */
(function () {
  'use strict';
  var root = document.querySelector('[data-product-root]');
  if (!root) return;

  var productData = JSON.parse(document.getElementById('ProductJson').textContent);
  var form = root.querySelector('form[data-product-form]');
  var idInput = form.querySelector('input[name="id"]');
  var priceEl = root.querySelector('[data-product-price]');
  var comparePriceEl = root.querySelector('[data-product-compare-price]');
  var atcBtn = form.querySelector('[data-atc-button]');
  var stickyBar = document.querySelector('[data-sticky-atc]');

  /* Track for "recently viewed" */
  if (window.AZTrackProduct) window.AZTrackProduct(productData.handle);

  /* ---------- Gallery ---------- */
  var mainStage = root.querySelector('[data-gallery-main]');
  root.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-media-thumb]');
    if (!thumb || !mainStage) return;
    var tpl = document.getElementById('media-' + thumb.getAttribute('data-media-thumb'));
    if (tpl) {
      mainStage.innerHTML = tpl.innerHTML;
      root.querySelectorAll('[data-media-thumb]').forEach(function (t) { t.removeAttribute('aria-current'); });
      thumb.setAttribute('aria-current', 'true');
      var v = mainStage.querySelector('video');
      if (v) v.play().catch(function () {});
    }
  });

  /* ---------- Variant selection ---------- */
  function currentOptions() {
    return Array.prototype.map.call(form.querySelectorAll('[data-option-select]'), function (s) { return s.value; });
  }
  function findVariant(options) {
    return productData.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === options[i]; });
    });
  }
  function updateVariant() {
    var variant = findVariant(currentOptions());
    var strings = (window.AZ && window.AZ.strings) || {};
    if (!variant) {
      atcBtn.disabled = true;
      atcBtn.textContent = strings.unavailable || 'Nicht verfügbar';
      return;
    }
    idInput.value = variant.id;
    if (priceEl) priceEl.textContent = window.AZFormatMoney(variant.price);
    if (comparePriceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceEl.hidden = false;
        comparePriceEl.textContent = window.AZFormatMoney(variant.compare_at_price);
      } else { comparePriceEl.hidden = true; }
    }
    atcBtn.disabled = !variant.available;
    atcBtn.textContent = variant.available ? (strings.addToCart || 'In den Warenkorb') : (strings.soldOut || 'Ausverkauft');
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
    if (variant.featured_media && variant.featured_media.id) {
      var thumb = root.querySelector('[data-media-thumb="' + variant.featured_media.id + '"]');
      if (thumb) thumb.click();
    }
    if (stickyBar) {
      var sp = stickyBar.querySelector('[data-sticky-price]');
      if (sp) sp.textContent = window.AZFormatMoney(variant.price);
    }
  }
  form.querySelectorAll('[data-option-select]').forEach(function (s) {
    s.addEventListener('change', updateVariant);
  });

  /* ---------- Sticky mobile ATC ---------- */
  if (stickyBar && atcBtn) {
    var observer = new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '-80px 0px 0px 0px' });
    observer.observe(atcBtn);
    stickyBar.querySelector('[data-sticky-submit]').addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
  }

  /* ---------- Recently viewed section ---------- */
  var rvContainer = document.querySelector('[data-recently-viewed]');
  if (rvContainer && window.AZRenderRecentlyViewed) {
    window.AZRenderRecentlyViewed(rvContainer, productData.handle, 4);
  }
})();
